
import { createContext } from 'react';
import { QuotesContextType } from '../types';

export const QuotesContext = createContext<QuotesContextType | undefined>(undefined);
